var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 96 97",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 9.64286C69.44 9.64286 86.8571 27.06 86.8571 48.5C86.8571 69.94 69.44 87.3571 48 87.3571C26.56 87.3571 9.14286 69.94 9.14286 48.5C9.14286 27.06 26.56 9.64286 48 9.64286ZM48 0.5C21.4857 0.5 0 21.9857 0 48.5C0 75.0143 21.4857 96.5 48 96.5C74.5143 96.5 96 75.0143 96 48.5C96 21.9857 74.5143 0.5 48 0.5Z",
    fill: "fillColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0743 27.9286H62.6286C62.0343 27.9286 61.4401 28.1571 61.0286 28.6143L47.5886 42.0543L34.1486 28.6143C33.7372 28.2029 33.1429 27.9286 32.5486 27.9286H26.1029C24.0458 27.9286 23.0401 30.3971 24.5029 31.8143L41.1886 48.5L24.5029 65.1857C23.0858 66.6029 24.0915 69.0714 26.1029 69.0714H32.5486C33.1429 69.0714 33.7372 68.8429 34.1486 68.3857L47.5886 54.9457L61.0286 68.3857C61.4401 68.7971 62.0343 69.0714 62.6286 69.0714H69.0743C71.1315 69.0714 72.1372 66.6029 70.6743 65.1857L53.9886 48.5L70.6743 31.8143C72.0915 30.3971 71.0858 27.9286 69.0743 27.9286Z",
    fill: "fillColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboCloseCircle);
export default __webpack_public_path__ + "static/media/FBOCloseCircle.a0ced48c7284f3d68004ed7b9e37771f.svg";
export { ForwardRef as ReactComponent };